/* eslint-disable camelcase */
import React from 'react';
import {
  Formik,
  Field,
} from 'formik';

import {
  Button,
  Select,
  TextField,
} from 'web-components';

import {
  Flex,
  Text,
} from 'web-styled';

const getPlanOptions = (plans: any[]) => plans.map(
  (plan: any) => {
    const value = plan.id;
    let label = `${plan.name} - $${plan.price} `;

    if (plan.interval === 'year') {
      label += 'annually';
    }

    if (plan.interval === 'month') {
      label += 'monthly';
    }

    return {
      label,
      value,
    };
  },
);

type Props = {
  plans: Array<object>,
  plan: any;
  setPlan: Function,
};

const SubscriptionForm = ({
  plan,
  plans,
  setPlan,
}: Props) => {
  const onSubmit = (values: any) => {
    const { coupon } = values;
    setPlan({
      payload: {
        ...(coupon ? {
          coupon,
        } : {}),
        plan_id: values.plan.value,
      },
      plan: plans.find((p: any) => p.id === values.plan.value),
    });
  };

  const options = getPlanOptions(plans);
  const initialValues = {
    plan: plan?.id
      ? options.find(option => option.value === plan?.id)
      : '',
    coupon: '',
  };

  return (
    <Flex
      shrink={0}
      padding="5% calc(15% + 10px)"
      width="calc(100% + 20px)"
      borderBottom="1px solid #ccc"
    >
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={onSubmit}
      >
        {({ setFieldValue, values, handleSubmit }) => (
          <Flex
            column
            justify="center"
            align="center"
            fillSpace
            as="form"
            onSubmit={handleSubmit}
          >
            <Flex
              column
              width="100%"
              margin="0 0 15px 0"
            >
              <Text>
                Select plan
              </Text>
              <Select
                name="plan"
                value={values.plan}
                options={options}
                onChange={option => setFieldValue('plan', option)}
                isSearchable={false}
                styles={{
                  container: provided => ({
                    ...provided,
                    width: '100%',
                  }),
                  menu: provided => ({
                    ...provided,
                    marginTop: 1,
                  }),
                }}
              />
            </Flex>
            <Field
              name="coupon"
              color="#333"
              label="Coupon"
              height="38px"
              spacing="none"
              component={TextField}
              autoComplete="off"
              margin="0 0 15px 0"
            />
            <Flex
              justify="space-around"
              width="100%"
            >
              <Button
                type="submit"
                appearance="primary"
              >
                Apply
              </Button>
            </Flex>
          </Flex>
        )}
      </Formik>
    </Flex>
  );
};

export default SubscriptionForm;
